<div class="content-wrapper pt-3">
    <section class="wrapper overflow-hidden pt-3 spacing">
        <app-banner [bannerData]="landingPageBanner"></app-banner>
    </section>
    <section class="wrapper overflow-hidden" [ngClass]="{ 'pt-11 pt-6': landingPageBanner?.services?.show }">
        <app-services *ngIf="landingPageBanner?.services?.show" [servicesData]="landingPageBanner"></app-services>
    </section>

    <section appLazyLoad #lazyImageText="appLazyLoad" (visible)="chargeLandingPage()" *ngIf="landingPageData?.imageAndText?.show" class="mt-15 wrapper bg-image section-frame default-background mt-3">
        <mat-spinner *ngIf="!isLoaded" color="primary" class="spinner-container"></mat-spinner>
        <div *ngIf="isLoaded && lazyImageText.isVisible" class="container py-14 pt-md-16 pt-lg-0 pb-md-12">

            <div class="row text-center mb-13">
                <div class="col-lg-12 mx-auto">
                    <div class="mt-lg-n23 mt-xl-n21">
                        <div class="spinner-center">
                            <mat-spinner *ngIf="!landingPageData?.imageAndText?.img"></mat-spinner>
                        </div>
                        <figure class="rounded-xl b-white">
                            <img class="img-size" dynamicImage *ngIf="landingPageData?.imageAndText?.img"  [baseImageSrc]="landingPageData?.imageAndText?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.lg]" alt="patnersWorking" />
                        </figure>
                    </div>
                </div>
            </div>
            <div class="row gx-md-8 gx-lg-12 gy-6 gy-lg-0 mb-13 mb-0">
                <div class="col-lg-6">
                    <h1 class="display-2 mb-0 text-white">{{ landingPageData?.imageAndText?.title }}</h1>
                    <p class="lead fs-lg mb-3 text-inverse pt-10">{{ landingPageData?.imageAndText?.secondDescription }}</p>
                </div>
                <div class="col-lg-6">
                    <p class="lead fs-lg mb-3 text-inverse" [innerHTML]="landingPageData?.imageAndText?.description"></p>
                </div>
            </div>
        </div>
    </section>

    <section class="wrapper overflow-hidden" appLazyLoad #lazyProjects="appLazyLoad">
        <app-our-projects *ngIf="landingPageData?.projects?.show && lazyProjects.isVisible" [landingPageData]="landingPageData"></app-our-projects>
    </section>

    <section class="wrapper pattern-wrapper bg-image section-frame default-background" *ngIf="landingPageData?.process?.show" appLazyLoad #lazyProcess="appLazyLoad">
        <app-our-working-process *ngIf="lazyProcess.isVisible" [ourWorkingProcessData]="landingPageData"></app-our-working-process>
    </section>

    <section class="wrapper overflow-hidden" *ngIf="landingPageData?.solutions?.show " appLazyLoad #lazySolutions="appLazyLoad">
        <div *ngIf="lazySolutions.isVisible" class="container py-15 py-md-17 m-b">
            <app-design [designData]="landingPageData"></app-design>
        </div>
    </section>

    <section class="overflow-hidden" *ngIf="landingPageData?.testimonials?.show" appLazyLoad #lazyTeam="appLazyLoad">
        <div class="container our-team-container margin-bottom pb-20 pb-md-22">
            <app-our-team *ngIf="lazyTeam.isVisible" [ourTeamData]="landingPageData"></app-our-team>
        </div>
    </section>

    <section class="overflow-hidden" *ngIf="landingPageData?.meetTheTeam?.show" appLazyLoad #lazyEmployeesPlans="appLazyLoad">
        <app-our-employees *ngIf="lazyEmployeesPlans.isVisible" [homeView]="true" [landingPageData]="landingPageData"></app-our-employees>
    </section>

    <section class="overflow-hidden" *ngIf="landingPageData?.pricing?.show" appLazyLoad #lazyEmployeesPlans="appLazyLoad">
        <app-plans *ngIf="landingPageData?.pricing?.show && lazyEmployeesPlans.isVisible" [plansData]="landingPageData"></app-plans>
    </section>

    <section class="mb-12r" appLazyLoad #lazyBrands="appLazyLoad">
        <app-clients-brand-scroll *ngIf="landingPageData?.clients?.show && lazyBrands.isVisible" [landingPageData]="landingPageData"></app-clients-brand-scroll>
    </section>

</div>
<div class="progress-wrap">
    <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
</div>
